import router from "@/router"
import Vue from "vue"
import { get, merge, omit } from "lodash"
import { MIXINS } from "@/utils/mixins"

const state = {
  fbPixelIds: {
    "general": process.env.FB_PIXEL_ID_GENERAL || null,
    "leagueoflegends": process.env.FB_PIXEL_ID_LOL || null,
    "fortnite": process.env.FB_PIXEL_ID_FNBR || null,
    "hearthstone": process.env.FB_PIXEL_ID_HS || null,
    "super-smash-bros-ultimate": process.env.FB_PIXEL_ID_SSBU || null,
    "csgo": process.env.FB_PIXEL_ID_CSGO || null,
    "overwatch": process.env.FB_PIXEL_ID_OW || null,
  },
  gaConversionLabels: {
    "Subscription": process.env.GA_CONVERSION_LABEL_SUBSCRIPTION || null,
    "Purchase": process.env.GA_CONVERSION_LABEL_PURCHASE || null,
    "Sign-up": process.env.GA_CONVERSION_LABEL_SIGNUP || null,
    "Trial Subscription":
      process.env.GA_CONVERSION_LABEL_TRIAL_SUBSCRIPTION || null,
  },
}

const getters = {}

const mutations = {}

const actions = {
  async fbQuery (
    { state, dispatch, rootGetters },
    { event, properties, isStatic }
  ) {
    const getGameByKey = rootGetters["Games/getGameByKey"]
    if (!isStatic) {
      await dispatch("User/loadUserActiveGames", null, { root: true })
    }
    let gameKey = rootGetters["User/currentActiveGame"]
    if (!gameKey) {
      gameKey = router.currentRoute.params.game
    }
    if (!gameKey) {
      const urlGame = router.currentRoute.path.split("/")[1]
      const game = getGameByKey(urlGame)
      if (game) {
        gameKey = urlGame
      }
    }
    const fbIds = ["general"]
    if (gameKey) {
      fbIds.push(gameKey)
    }
    fbIds.forEach(fbId => {
      const pixelId = state.fbPixelIds[fbId]
      if (pixelId) {
        Vue.analytics.fbq.query("trackSingle", pixelId, event, properties)
      }
    })
  },
  initFbq ({ state }) {
    for (let fbPixelId of Object.values(state.fbPixelIds)) {
      Vue.analytics.fbq.init(fbPixelId)
    }
  },
  async analyticsEvent ({ state }, { event, properties }) {
    MIXINS.methods.trackAnalyticsEvent(event, properties)
  },
  async analyticsConversion ({ state }, { conversionName, properties }) {
    let conversionLabel = get(state.gaConversionLabels, conversionName, null)
    if (conversionLabel) {
      let conversionProperties = merge(
        {
          send_to: [process.env.GA_CONVERSION_ID, conversionLabel].join("/"),
        },
        omit(properties, ["send_to"])
      )
      MIXINS.methods.trackAnalyticsEvent("conversion", conversionProperties)
    }
  },
  initRedditPixel ({ state }) {
    if (typeof rdt !== "undefined") {
      // eslint-disable-next-line no-undef
      rdt("init", process.env.REDDIT_PIXEL_ADVERTISER_ID)
    }
  },
  async trackRedditPixelEvent ({ state }, { event }) {
    if (typeof rdt !== "undefined") {
      // eslint-disable-next-line no-undef
      rdt("track", event)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/tracking.js